var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gvl-input-data" },
    [
      _c(
        "v-expansion-panels",
        {
          attrs: { accordion: "", tile: "", multiple: "" },
          model: {
            value: _vm.panel,
            callback: function($$v) {
              _vm.panel = $$v
            },
            expression: "panel"
          }
        },
        [
          _c(
            "v-expansion-panel",
            [
              _c("v-expansion-panel-header", [
                _vm._v("Angaben zur Antragstellerin bzw. dem Antragsteller")
              ]),
              _c(
                "v-expansion-panel-content",
                { attrs: { eager: "" } },
                [_c("applicant-information", { ref: "applicant-info" })],
                1
              )
            ],
            1
          ),
          _c(
            "v-expansion-panel",
            [
              _c("v-expansion-panel-header", [_vm._v("Bankverbindung")]),
              _c(
                "v-expansion-panel-content",
                { attrs: { eager: "" } },
                [_c("bank-details", { ref: "bank-details" })],
                1
              )
            ],
            1
          ),
          _c(
            "v-expansion-panel",
            [
              _c("v-expansion-panel-header", [
                _vm._v("Angaben zur Förderberechtigung")
              ]),
              _c(
                "v-expansion-panel-content",
                { attrs: { eager: "" } },
                [_c("funding-information", { ref: "funding-info" })],
                1
              )
            ],
            1
          ),
          _c(
            "v-expansion-panel",
            [
              _c("v-expansion-panel-header", [
                _vm._v("Künstlerisches Konzept")
              ]),
              _c(
                "v-expansion-panel-content",
                { attrs: { eager: "" } },
                [_c("artistic-concept", { ref: "artistic-concept" })],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-btn",
        {
          staticClass: "mt-5",
          attrs: { color: "primary", block: "" },
          on: { click: _vm.onCheckInfo }
        },
        [_vm._v("Angaben prüfen")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }